import '../App.css';
import axios from 'axios';
import { useEffect, useState } from 'react';
import React from 'react';
import { Form, Heading, Checkbox, RadioGroup, Radio, TextField, TextArea, Text, CheckboxGroup, Flex } from '@adobe/react-spectrum';
import { logReadingComprehensionSelection } from '../logging';



function Questions({ currentIndex, splitView, questions, testResponses, setTestResponses, participantId, workerId, condition, experiment }) {
    function updateTestResponses(e, index) {
        var newTestResponses = [...testResponses];
        if (e.length === 0) {
            newTestResponses[index] = {};
            if (experiment === "exp2-highlights") {
                let event = {
                    timestamp: Date.now(),
                    workerId: workerId,
                    participantId: participantId,
                    experiment: experiment,
                    condition: condition,
                    questionIndex: index,
                    response: ""
                }
                logReadingComprehensionSelection(event);
            }
            else if (experiment === "exp3-withinHighlights") {
                let event = {
                    timestamp: Date.now(),
                    workerId: workerId,
                    participantId: participantId,
                    experiment: experiment,
                    condition: condition,
                    currentIndex: currentIndex,
                    questionIndex: index,
                    response: ""
                }
                logReadingComprehensionSelection(event);
            }
            else {
                logReadingComprehensionSelection({ participantId: participantId, questionIndex: index, response: "" });
            }
        }
        else {
            newTestResponses[index] = { questionIndex: index, response: e };
            if (experiment === "exp2-highlights") {
                let event = {
                    timestamp: Date.now(),
                    workerId: workerId,
                    participantId: participantId,
                    experiment: experiment,
                    condition: condition,
                    questionIndex: index,
                    response: e
                }
                logReadingComprehensionSelection(event);
            }
            else if (experiment === "exp3-withinHighlights") {
                let event = {
                    timestamp: Date.now(),
                    workerId: workerId,
                    participantId: participantId,
                    experiment: experiment,
                    condition: condition,
                    currentIndex: currentIndex,
                    questionIndex: index,
                    response: e
                }
                logReadingComprehensionSelection(event);
            }
            else {
                logReadingComprehensionSelection({ participantId: participantId, questionIndex: index, response: e });
            }
        }
        setTestResponses(newTestResponses);
    }


    return (
        <div id="textToRead" className={splitView ? "documentReader smallDoc" : "documentReader"} onCopy={e => e.preventDefault()}>
            <Form maxWidth="size-4000">
                <Heading level={2} width="size-700" marginBottom="size-100" marginTop="size-0">Test</Heading>
                <Text>All questions are mandatory.</Text>
                {questions.map((question, questionIndex) => {
                    // Render questions and options based on what is in the JSON file      
                    if (question.type === "true-false") {
                        return (
                            <>
                                <RadioGroup onChange={(e) => updateTestResponses(e, questionIndex)} label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">{question.question}</Heading>}>
                                    <Radio value="true">True</Radio>
                                    <Radio value="false">False</Radio>
                                </RadioGroup>
                            </>
                        );
                    }

                    else if (question.type === "multiple-choice") {
                        return (
                            <>
                                <RadioGroup onChange={(e) => updateTestResponses(e, questionIndex)} label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">{question.question}</Heading>}>
                                    {question.options.map((option, index) => {
                                        var value = ""
                                        if (index === 0) {
                                            value = "A";
                                        }
                                        else if (index === 1) {
                                            value = "B";
                                        }
                                        else if (index === 2) {
                                            value = "C";
                                        }
                                        else if (index === 3) {
                                            value = "D";
                                        }
                                        else if (index === 4) {
                                            value = "E";
                                        }
                                        return (<Radio value={value}>{option}</Radio>)
                                    })}
                                </RadioGroup>
                            </>
                        );
                    }

                    else if (question.type === "short-answer") {
                        return (
                            <>
                                <TextArea onChange={(e) => updateTestResponses(e, questionIndex)} label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">{question.question}</Heading>} />
                            </>
                        );

                    }

                    else if (question.type === "fill-blank") {
                        var nonBlanks = question.question.split("_");
                        return (
                            <>
                                <Flex gap="size-100" direction="row" width="100%">
                                    {nonBlanks.map((nonBlank, index) => {
                                        if (index === (nonBlanks.length - 1)) {
                                            return (<Heading level={4} marginBottom="size-100" marginTop="size-0">{nonBlank}</Heading>);
                                        }
                                        else {
                                            return (
                                                <TextField onChange={(e) => updateTestResponses(e, questionIndex)} label={<Heading level={3} marginBottom="size-100" marginTop="size-0">{nonBlank}</Heading>} labelPosition="side" labelAlign="start" />
                                            );
                                        }
                                    })}
                                </Flex>
                            </>
                        );
                    }

                    else if (question.type === "multiple-select") {
                        return (
                            <>
                                <CheckboxGroup onChange={(e) => updateTestResponses(e, questionIndex)} label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">{question.question} (select all that apply)</Heading>}>
                                    {question.options.map((option, index) => {
                                        return (<Checkbox value={option}>{option}</Checkbox>)
                                    })}
                                </CheckboxGroup>
                            </>
                        );
                    }


                })}
            </Form>
        </div>
    );
}

export default Questions;